import React from "react";
import { createRoot } from "react-dom/client";

import { NavItemBadge } from "bundles/navigation/components/NavItemBadge";

// Mounted by hand, not via ReactOnRails.register (ENG-17643, mirrors the
// ENG-17355 build-version-monitor-bundle pattern): this pack is queued onto
// EVERY authenticated page via ApplicationController#view_context, because
// the left nav (and any badge in it) renders on every page regardless of
// which page-specific bundle that page also loads — react_component's
// automatic pack resolution only knows about the current page's own bundle,
// not this shared one.
//
// Unlike the monitor's single `data-turbo-permanent` root, these placeholder
// spans are ordinary (non-permanent) markup rendered fresh by the server on
// every page load — nearly every nav row is `data-turbo="false"`, so every
// click is a real full-page navigation, not a Turbo Drive body swap. No
// "already mounted" guard is needed: there is no persisted DOM node for
// createRoot() to double-mount onto.
document.querySelectorAll(".js-nav-new-badge").forEach((el) => {
  const { preferenceNamespace, preferenceKey } = el.dataset;
  if (!preferenceNamespace || !preferenceKey) return;

  createRoot(el).render(
    <NavItemBadge
      preferenceNamespace={preferenceNamespace}
      preferenceKey={preferenceKey}
    />
  );
});
